import useConfig from './useConfig.js'
const { mergeWithDefaults, memoizeDynamicConfig } = useConfig()

const env = import.meta.env
const mode = env.MODE

let config = {
  default: {
    theme: env.VITE_THEME,
    defaultLocale: env.VITE_DEFAULT_LOCALE,

    api: {
      hostname: env.VITE_API_HOSTNAME,
      port: env.VITE_API_PORT,
      host: (config, _opts) => {
        let port = config.api.port ? `:${config.api.port}` : ""
        return `${config.api.hostname}${port}`
      },
      baseUrl: (config, _opts) => {
        return `${config.api.host()}/pwa`
      }
    },

    runtime: {
      basePath: "/",
      mode: (_config, opts) => opts.mode,
      isDevelopment: (config, opts) => opts.mode === 'development',
      isProduction: (config, opts) => opts.mode === 'production'
    }
  },

  development: {},

  production: {}
}

if (mode === "production") config = mergeWithDefaults(config.default, config.production)
else config = mergeWithDefaults(config.default, config.development)
memoizeDynamicConfig(config, mode, env)

const AppConfig = config
Object.freeze(AppConfig)
export default AppConfig

